import React, { useState, useEffect } from "react";
import { Grid, Button, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
// import history from "history.js";
import useAuth from "app/hooks/useAuth";
import LogoAssistaMais from "app/components/LogoAssistaMais/LogoAssistaMais";
import BotaoArredondado from "app/components/BotaoArredondado";
import "./style.scss";
import LoginForm from "app/components/SignIn/loginScreen";
// import SetPasswordForm from "../../../components/SignUp/setPasswordScreen";
// import PasswordForm from "../../../components/SignIn/passwordScreen";
// import { changePassword, signUp } from "../../actions/services/userService";
// import { signIn } from "../../actions/services/authService";
import { ToastContainer, toast } from "react-toastify";
import { AnimatePresence } from "framer-motion";
// import { useSearchParams, useRouter } from "next/navigation";
// import PasswordScreen from "../../components/ChangePassword/changePassword";
import { SignUp } from "app/components/SignUp";
import ForgotScreen from "app/components/SignIn/forgotScreen";
import OnBoardingPainel from "app/components/OnboardingPainel";
// import { autenticar } from "../../actions/assistamais/api";
// import { gravarDados } from "../../utils/Session";
import { useHistory } from "react-router-dom";
import { useToastify } from "app/hooks/useToastify";

const useStyles = makeStyles(({ palette, ...theme }) => ({
  cardHolder: {
    background: "#FFFFFF",
  },
  card: {
    maxWidth: 800,
    borderRadius: 12,
    margin: "1rem",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  texto: {
    fontFamily: "Roboto",
    fontSize: "24px",
    lineHeight: "32px",
    textAlign: "center",
    width: "328px",
    height: "50px",
  },
  link: {
    fontSize: "16px",
    lineHeight: "19px",
    textAlign: "center",
    height: "50px",
    fontWeight: "500",
    width: "100%",
  },
}));

const JwtLogin = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { login, forgotpassword } = useAuth();
  const classes = useStyles();

  const history = useHistory();

  const toast = useToastify();

  const [socialId, setSocialId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [checkedUser, setCheckedUser] = useState(false);
  const [existUser, setExistUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState("");
  const [statusLoginForm, setStatusLoginForm] = useState(true);
  const [statusForgot, setStatusForgot] = useState(false);
  const [statusSetPassword, setStatusSetPassword] = useState(false);
  const [passwordChanged, setPasswordChanged] = useState(false);
  const [passwordChangedMessage, setPasswordChangedMessage] = useState("");
  // const searchParams = useSearchParams()
  // const router = useRouter();
  // const passwordResetKey = searchParams?.get('password-reset-key');
  const passwordResetKey = "";

  const handleRedirectSenha = () => {
    setStatusLoginForm(false);
    setStatusForgot(true);
    // router.push('/requestPassword')
  };

  const handleRedirectLogin = () => {
    setStatusLoginForm(true);
    setStatusForgot(false);
    // router.push('/requestPassword')
  };

  const handleSignIn = async (socialId, password) => {
    if (!socialId || !password) {
      toast.show("warning", "Login e senha são obrigatórios")
      return;
    }
    try {
      setIsLoading(true);
      
      // const backendTokenSliced = process.env.backendToken?.slice(0, 15);

      // if (!backendTokenSliced) {
      //   throw new Error("backendToken não está definido");
      // }

      // const cyptedSocialId = btoa(
      //   encodeURIComponent(socialId.trim() + backendTokenSliced.trim())
      // );
      // const cyptedPassoword = btoa(password.trim() + backendTokenSliced.trim());

      let response = await login(socialId, password);

      if (!response.status) {
        toast.show("error", response.message);
      } else {
        history.push("/");
      }

    } catch (error) {
      toast.show("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePassword = async (email) => {
    return await forgotpassword(email);
    // setIsLoading(true);
    // const response = await changePassword({
    //   key: passwordResetKey,
    //   code: code,
    //   password: password,
    // });
    // const changed = response.status;
    // setPasswordChangedMessage(response.message);
    // setPasswordChanged(changed);
    // setIsLoading(false);
    // if (!changed) {
    //   toast.error(response.message, {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    // }
  };

  const handleCodeValidate = async () => {
    try {
      await forgotpassword(values.email);
      handleOpen();
      setTimeout(() => {
        handleClose();
        history.push("/session/signin");
      }, 5000);
    } catch (e) {
      setMessage(e.message);
    } finally {
      setSubmitting(false);
    }
    // try {
    //   setIsLoading(true);
    //   await signIn({ social_id: socialId, password: password });

    //   // router.push('/');
    // } catch (error: any) {
    //   toast.error(error.response.data.message, {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    // } finally {
    //   setIsLoading(false);
    // }
  };

  useEffect(() => {
    const statusPass = checkedUser && existUser;
    const statusSetPass = checkedUser && !existUser;
    setStatusLoginForm(!checkedUser && !passwordResetKey);
    // setStatusPassword(statusPass)
    setStatusSetPassword(statusSetPass);
  }, [checkedUser, passwordResetKey, existUser]);

  const validationSchema = Yup.object().shape({
    cnpj: Yup.string().required("Digite um e-mail válido"),
    password: Yup.string().required("Digite sua senha"),
  });

  const handleFormSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    try {
      const retornoLogin = await login(values.cnpj, values.password);

      if (!retornoLogin.status) {
        setMessage(retornoLogin.message);
      } else {
        history.push("/");
      }
    } catch (e) {
      console.error(e);
      setMessage(e.message);
      setLoading(false);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section>
      <ToastContainer />
      <div className="tw-grid tw-grid-cols-2 tw-h-screen">
        <OnBoardingPainel />
        {passwordChanged ? (
          <div className="flex flex-col mx-auto w-full max-md:ml-0 max-md:w-full">
            <div className="flex border-neutral-800 border-2 flex-col self-stretch p-20 my-auto h-full w-full text-xl shadow bg-white rounded-[48px] max-md:px-5 max-md:mt-10 max-md:max-w-full">
              <SignUp.Root>
                <SignUp.Title text={passwordChangedMessage} />
                <SignUp.Actions>
                  <SignUp.Action
                    id="login"
                    onClick={() => handleRedirectLogin()}
                    text="Login"
                    className="justify-center mt-10 items-center text-center p-2.5 w-full text-white rounded-lg shadow-sm bg-[linear-gradient(90deg,#E13441_0%,#FAAE2E_100%)]"
                  />
                </SignUp.Actions>
              </SignUp.Root>
            </div>
          </div>
        ) : (
          <AnimatePresence>

            {statusLoginForm && (
              <LoginForm
                isLoading={isLoading}
                type="login"
                handleRedirectSenha={handleRedirectSenha}
                signIn={handleSignIn}
              />
            )}

            {statusForgot && (
              <ForgotScreen
                passwordKey={passwordResetKey}
                changePassword={handleChangePassword}
                handleRedirectLogin={handleRedirectLogin}
                saveCode={setCode}
                codeValidate={handleCodeValidate}
                savePassword={setPassword}
              />
            )}

          </AnimatePresence>
        )}
      </div>
    </section>
    // <div className={clsx('flex items-start justify-center min-h-full-screen pt-20', classes.cardHolder)}>
    //     <div className={classes.card}>
    //         <Grid container>
    //             <Grid item lg={12} md={12} sm={12} xs={12}>
    //                 <LogoAssistaMais />
    //             </Grid>
    //             <Grid item lg={12} md={12} sm={12} xs={12}>
    //                 <div className={clsx('flex justify-center items-center min-w-full mb-10', classes.texto)}>
    //                     Acesso a Área Administrativa
    //                 </div>
    //             </Grid>

    //             <Grid item lg={12} md={12} sm={12} xs={12}>
    //                 <div className="h-full relative">
    //                     <Formik
    //                         initialValues={{ cnpj: '', password: '' }}
    //                         validationSchema={validationSchema}
    //                         onSubmit={handleFormSubmit}
    //                     >
    //                         {({ isSubmitting }) => (
    //                             <Form>
    //                                 <Field
    //                                     className="w-full"
    //                                     variant="outlined"
    //                                     size="small"
    //                                     label=""
    //                                     placeholder="Digite o e-mail"
    //                                     name="cnpj"
    //                                     as={TextField}
    //                                     fullWidth
    //                                 />
    //                                 <ErrorMessage name="cnpj" component="div" className="text-error" />

    //                                 <Field
    //                                     className="mt-6 w-full"
    //                                     placeholder="Digite sua senha"
    //                                     variant="outlined"
    //                                     size="small"
    //                                     name="password"
    //                                     type="password"
    //                                     as={TextField}
    //                                     fullWidth
    //                                 />
    //                                 <ErrorMessage name="password" component="div" className="text-error" />

    //                                 {message && (
    //                                     <p className="text-error">{message}</p>
    //                                 )}

    //                                 <div className="flex flex-wrap items-center justify-center mb-12 mt-8">
    //                                     <BotaoArredondado value="Entrar" disabled={isSubmitting || loading} />
    //                                 </div>
    //                             </Form>
    //                         )}
    //                     </Formik>

    //                     <Button
    //                         className={clsx('text-primary', classes.link)}
    //                         onClick={() => history.push('/session/forgot-password')}
    //                     >
    //                         ESQUECI MINHA SENHA
    //                     </Button>
    //                 </div>
    //             </Grid>
    //         </Grid>
    //     </div>
    // </div>
  );
};

export default JwtLogin;
